import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { MOMENTS } from "MVVM/GraphQL/matchHistory";
import { TMoment, TMatchVodRoundMarker } from "MVVM/Views/MatchHistory/@types";

export const momentRound = (m: TMoment): number | null => {
  const parts = m.timelineLabel?.split(":") || [];
  const raw = parts.length === 2 ? parts[1].trim() : "";
  const n = Number(raw);
  return Number.isFinite(n) && raw !== "" ? n : null;
};

export const useMatchVodViewerModel = (
  matchId?: string,
  playerGameId?: string | null,
  roundMarkers?: TMatchVodRoundMarker[] | null,
) => {
  const { data, loading } = useQuery(MOMENTS, {
    variables: {
      matchId,
      playerGameId,
      sort: "SCORE",
      type: "ALL",
    },
    skip: !matchId || !playerGameId,
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  const moments: TMoment[] = data?.moments || [];

  const markerByRound = useMemo(() => {
    const map = new Map<number, TMatchVodRoundMarker>();
    (roundMarkers || []).forEach((m) => map.set(m.round, m));
    return map;
  }, [roundMarkers]);

  return { moments, loading, markerByRound };
};
